<template>
  <div id="modalDetail">
    <div
      id="modal-idea-detail"
      class="modal fade show"
      tabindex="-1"
      role="dialog"
      style="display: block; background-color: rgba(0, 0, 0, 0.5)"
      @click="close"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content" ref="modalContent" @click.stop>
          <div class="modal-header bg-orange rounded-0">
            <h5 class="modal-title text-center text-white mx-auto">
              FİKİR DETAYI
            </h5>
            <button
              @click="close"
              type="button"
              class="close"
              id="btnDetailClose"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="container mb-3 mw-100">
            <div class="row pl-3 pl-sm-5 mb-2 modal-bar">Fikir Bilgileri</div>
            <dl class="row px-3 px-sm-5 pt-3 mb-0">
              <dt>Fikir No</dt>
              <dd>{{ detailData.SuggestionNumber }}</dd>
              <dt>Şirket</dt>
              <dd>{{ detailData.CompanyName }}</dd>
              <dt>Fikri Yapan</dt>
              <dd class="text-uppercase">
                {{ detailData.CreatedCustomerName }} (
                {{ detailData.CreatedCustomerCompanyName }} )
              </dd>
              <dt>Bölge</dt>
              <dd>{{ detailData.OfficeLocation }}</dd>
              <dt>Fikir Tarihi</dt>

              <dd>{{ detailData.SuggestionDate | newDateFormatterFilter }}</dd>
              <dt>Fikir Sahibi Departman</dt>
              <dd>{{ detailData.CreatedCustomerDepartment }}</dd>
              <dt>Görev</dt>
              <dd>{{ detailData.JobTitle }}</dd>
              <dt>Fikir Sahibi Bölüm</dt>
              <dd>{{ detailData.CreatedCustomerSection }}</dd>

              <dt>Statü</dt>
              <dd class="single">
                {{ detailData.SuggestionStatusName }}
              </dd>

              <dt v-if="detailData.SuggestionTypeId != 3">Değer Akımı</dt>
              <dd v-if="detailData.SuggestionTypeId != 3" class="single">
                {{ detailData.valuecurrentname }}
              </dd>

              <template>
                <dt>Proje Adı</dt>
                <dd class="single">{{ detailData.Title }}</dd>
                <dt>Problem Tanımı (Mevcut Durum)</dt>
                <dd class="single">{{ detailData.ProblemDefinition }}</dd>
                <dt>Hedef Tanımı</dt>
                <dd class="single">{{ detailData.TargetDefinition }}</dd>
                <dt>Kapsam</dt>
                <dd class="single">{{ detailData.Scope }}</dd>
                <dt>Fırsat Tanımı (Yan Faydalar)</dt>
                <dd class="single">{{ detailData.OpportunityDefinition }}</dd>
                <dt>Departman</dt>
                <dd class="single">{{ detailData.SelectedDepartments }}</dd>
                <dt>Bölüm</dt>
                <dd class="single">{{ detailData.SelectedSections }}</dd>
                <dt>Değer Akım Yöneticileri</dt>
                <dd class="single">{{ valueCurrent }}</dd>
                <dt>Ekip Liderleri</dt>
                <dd class="single">{{ teamLead }}</dd>
                <dt>Ekip Üyeleri</dt>
                <dd class="single">{{ team }}</dd>
                <dt>Proje Başlangıç Tarihi</dt>
                <dd class="single">
                  {{ detailData.ProjectStartDate | newDateFormatterFilter }}
                </dd>
                <dt>Proje Hayata Geçiş Tarihi</dt>
                <dd class="single">
                  {{ detailData.ProjectEndDate | newDateFormatterFilter }}
                </dd>
                <dt>Proje Yılı</dt>
                <dd class="single">
                  <select
                    class="form-control"
                    data-val="true"
                    data-val-number="The field Value must be a number."
                    data-val-required="The Value field is required."
                    id="drpProjectYear"
                    name="ProjectYear.Value"
                    v-model="projectYear"
                  >
                    <option
                      v-for="item in projectYearList"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </option>
                  </select>
                </dd>
                <dt>Marka/Departman arası yayınlaştırılabilir mi?</dt>
                <dd class="single">
                  {{ detailData.Spreading ? "Evet" : "Hayır" }}
                </dd>
                <dt>
                  Projenin hayata geçirilebilmesi için IT geliştirmesi gerekli
                  mi?
                </dt>
                <dd class="single">
                  {{ detailData.ITDevolopment ? "Evet" : "Hayır" }}
                </dd>
                <dt>Eğitim Projesi midir?</dt>
                <dd class="single">
                  {{ detailData.LeanLeaderTraining ? "Evet" : "Hayır" }}
                </dd>
                <dt v-if="detailData.LeanLeaderTraining ">Eğitim Projeleri</dt>
                <dd class="single">
                  {{ detailData.TrainingProjectList }}
                </dd>
              </template>

              <dt>Doküman</dt>
              <dd class="single">
                <div
                  class="form-group custom-file icon-folder-alt"
                  v-if="detailData && detailData.DownloadFile.length > 0"
                >
                  <p
                    class="form-control d-flex align-items-center cursor-default"
                    v-for="item in detailData.DownloadFile"
                    :key="item.Id"
                  >
                    <span
                      class="flex-shrink-1 mr-1 hide-overflow-text cursor-default"
                      >{{ item.Filename }}.{{ item.Extension }}</span
                    >
                    <a
                      :href="
                        'data:' +
                        item.fileType +
                        ';base64,' +
                        item.DownloadBinary
                      "
                      :download="item.Filename + '.' + item.Extension"
                      class="btn btn-light text-blue-1 ml-auto fas fa-file-download"
                      title="Dokümanı bilgisayarınıza indirmek için tıklayın."
                      alt="Dokümanı bilgisayarınıza indirmek için tıklayın."
                      target="_blank"
                    >
                    </a>
                  </p>
                </div>
              </dd>

              <dt>Proje Bildirisi</dt>
              <dd
                class="single"
                v-if="
                  detailData &&
                  detailData.ProjectPresentationDocumentFiles.length > 0
                "
              >
                <div
                  class="form-group custom-file icon-folder-alt"
                  v-for="item in detailData.ProjectPresentationDocumentFiles"
                  :key="item.Id"
                >
                  <p
                    class="form-control d-flex align-items-center cursor-default"
                  >
                    <span
                      class="flex-shrink-1 mr-1 hide-overflow-text cursor-default"
                      >{{ item.Filename }}.{{ item.Extension }}</span
                    >
                    <a
                      :href="
                        'data:' +
                        item.fileType +
                        ';base64,' +
                        item.DownloadBinary
                      "
                      :download="item.Filename + '.' + item.Extension"
                      class="btn btn-light text-blue-1 ml-auto fas fa-file-download"
                      title="Dokümanı bilgisayarınıza indirmek için tıklayın."
                      alt="Dokümanı bilgisayarınıza indirmek için tıklayın."
                      target="_blank"
                    >
                    </a>
                  </p>
                </div>
              </dd>

              <dt v-if="detailData.DownloadFileProjectDocument">
                Proje Sunum Dokümanı
              </dt>
              <dd v-if="detailData.DownloadFileProjectDocument" class="single">
                <a
                  v-if="detailData.DownloadFileProjectDocument"
                  :href="
                    'data:' +
                    detailData.DownloadFileProjectDocument.fileType +
                    ';base64,' +
                    detailData.DownloadFileProjectDocument.DownloadBinary
                  "
                  :download="
                    detailData.DownloadFileProjectDocument.Filename +
                    '.' +
                    detailData.DownloadFileProjectDocument.Extension
                  "
                  class="innovation-pdf mr-4"
                  title="Dokümanı bilgisayarınıza indirmek için tıklayın."
                  alt="Dokümanı bilgisayarınıza indirmek için tıklayın."
                  target="_blank"
                >
                  {{ detailData.DownloadFileProjectDocument.Filename }}.{{
                    detailData.DownloadFileProjectDocument.Extension
                  }}
                  <span class="fas fa-file-download"></span>
                </a>
              </dd>
            </dl>

            <div class="row pl-3 pl-sm-5 mb-2 modal-bar">
              Etkileşim Bilgileri
            </div>
            <div class="row px-3 px-sm-5">
              <a
                @click="isComment = !isComment"
                class="article-comment-show icon-down"
                id="commentCount"
                >{{ detailData.CommentCount }} Yorum</a
              >
              <span class="article-comment-like">
                <i class="fas fa-thumbs-up">{{ detailData.LikeCount }}</i>
              </span>
              <button
                @click.stop="
                  supportShowModal(
                    isSuggestion == 'productidea-card'
                      ? detailData.SuggestionId
                      : detailData.Id
                  )
                "
                class="btn-article-action icon-arrow-right"
                data-toggle="modal"
                data-target="#modal-support"
              >
                <span
                  class="d-none d-sm-inline tooltipper"
                  title="Destek iste tooltip"
                  >Destek İste</span
                >
              </button>

              <article
                v-if="isComment"
                class="article-comment-container"
                type="Suggestion"
                objectid="718d7c1f-7dec-eb11-bacb-000d3ade7034"
              >
                <div id="suggestiondetailcomments">
                  <div
                    id="commentdiv"
                    v-for="comment in detailData.Comments"
                    :key="comment.Id"
                  >
                    <div
                      class="article-comment"
                      id="article-comment-id"
                      style="position: static"
                    >
                      <div class="article-comment-body">
                        <img
                          v-if="comment.UserProfileImage"
                          class="comment-user-img fallback-image"
                          :src="`data:image/png;base64, ${comment.UserProfileImage}`"
                          :alt="comment.UserName | getInitialsFilter"
                        />
                        <i
                          v-else
                          class="comment-user-img fallback-image"
                          :alt="comment.UserName | getInitialsFilter"
                          >{{ comment.UserName | getInitialsFilter }}</i
                        >
                        <span
                          >{{ comment.UserName }} (
                          {{ comment.CreatedCustomerCompanyName }} )</span
                        ><span
                          class="icon-clock"
                          :title="comment.CreatedOnUtc"
                          >{{ comment.CreatedOnUtc | dateDiffFilter }}</span
                        >
                        <p
                          style="
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                          "
                        >
                          {{ comment.CommentText }}
                        </p>
                      </div>
                      <div
                        class="article-comment-container"
                        style="display: none"
                      ></div>
                    </div>
                  </div>
                </div>

                <div class="article-reply">
                  <img
                    v-if="user.Data.UserProfileImage"
                    class="comment-user-img fallback-image"
                    :src="`data:image/png;base64, ${user.Data.UserProfileImage}`"
                    :alt="user.Data.UserName | getInitialsFilter"
                  />
                  <i
                    v-else
                    class="comment-user-img fallback-image"
                    :alt="user.Data.FullName | getInitialsFilter"
                    >{{ user.Data.FullName | getInitialsFilter }}</i
                  >
                  <div class="icon-note">
                    <textarea
                      id="make-comment-textarea"
                      class="autofit"
                      placeholder="Yorum Giriniz..."
                      v-model="commentText"
                      style="padding: 7px 20px !important"
                    ></textarea>
                  </div>
                  <div
                    class="text-right pt-3"
                    v-if="commentText && commentText.length > 0"
                  >
                    <button
                      class="btn-reply btn-cancel"
                      @click.stop="commentText = ''"
                    >
                      VAZGEÇ
                    </button>
                    <button
                      class="btn-reply add-comment-button"
                      @click.stop="createComment"
                    >
                      YANITLA
                    </button>
                  </div>
                </div>
              </article>
            </div>

            <div
              v-if="detailData.SuggestionTypeId != 3"
              class="row pl-5 mb-2 modal-bar"
            >
              Fikir Dağıtım Bilgileri
            </div>
            <dl
              v-if="detailData.SuggestionTypeId != 3"
              class="row px-5 pt-3 mb-0"
            >
              <dt>Fikir Dağıtıcısı</dt>
              <dd>
                {{ detailData.SuggestionExecutiveName }} (
                {{ detailData.SuggestionExecutiveCompanyName }} )
              </dd>

              <dt>İşlem Tarihi</dt>
              <dd>
                {{
                  detailData.SuggestionExecutiveProcessDate
                    | newDateFormatterFilter
                }}
              </dd>

              <dt>Fikir Dağıtıcısı Notu</dt>
              <dd class="single">{{ detailData.SuggestionExecutiveNote }}</dd>
            </dl>

            <div
              class="row pl-5 mb-2 modal-bar"
              v-if="detailData.SuggestionEvaluatorId != 0"
            >
              Fikir Değerlendirme Bilgileri
            </div>
            <dl
              class="row px-5 pt-3 mb-0"
              v-if="detailData.SuggestionEvaluatorId != 0"
            >
              <dt>Fikir Değerlendirici</dt>
              <dd>
                {{ detailData.SuggestionEvaluatorName }} (
                {{ detailData.SuggestionEvaluatorCompanyName }} )
              </dd>

              <dt>İşlem Tarihi</dt>
              <dd>
                {{
                  detailData.SuggestionEvaluatorProcessDate
                    | newDateFormatterFilter
                }}
              </dd>

              <dt>Sorun / Fırsat Hakkında</dt>
              <dd class="single">edd</dd>
              <dt>Fikir Hakkında</dt>
              <dd class="single"></dd>

              <dt>Fikir Değerlendirme Açıklaması</dt>
              <dd class="single"></dd>

              <dt>Beklenen Fayda (TL - adam saat/yıl)</dt>
              <dd class="single"></dd>

              <dt>Beklenen Uygulama Maliyeti</dt>
              <dd></dd>

              <dt>Uygulama Önerisi</dt>
              <dd>Projelendirilsin</dd>

              <dt>Önerilen Ekip</dt>
              <dd></dd>
              <dt>Çalışma Süresi</dt>
              <dd></dd>
            </dl>

            <div
              class="row pl-5 mb-2 modal-bar"
              v-if="detailData.SuggestionDecisionMakerId != 0"
            >
              Fikir Karar Verici Bilgileri
            </div>
            <dl
              class="row px-5 pt-3 mb-0"
              v-if="detailData.SuggestionDecisionMakerId != 0"
            >
              <dt>Fikir Karar Komitesi</dt>
              <dd>
                {{ detailData.SuggestionDecisionMakerName }} (
                {{ detailData.SuggestionDecisionMakerCompanyName }} )
              </dd>

              <dt>İşlem Tarihi</dt>
              <dd>
                {{
                  detailData.SuggestionDeciderProcessDate
                    | newDateFormatterFilter
                }}
              </dd>

              <dt>Fikir Karar Komitesi Notu</dt>
              <dd>{{ detailData.SuggestionDeciderNote }}</dd>
              <dt>Ekip Lideri</dt>
              <dd>
                {{ detailData.TeamLeaderName }}
              </dd>
            </dl>
            <div
              v-if="
                detailData.SuggestionStatusId == 8 &&
                detailData.IsContinuityTrackingActive
              "
            >
              <div class="row pl-3 pl-sm-5 mb-2 modal-bar">
                Proje Sürekliliğinin Kontrolü
              </div>
              <ContinuityTracking
                @send-continuity-tracking-update="sendContinuityTrackingUpdate"
                :detailData="detailData"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <SuggestionSupport
        v-if="isSuggestionSupport"
        @close="isSuggestionSupport = $event"
        :suggestionId="suggestionId"
      />
    </transition>
  </div>
</template>

<script>
import { suggestionService, suggestionRdService } from "../../../../services";
import { mapGetters } from "vuex";
import {
  suggestionStatus,
  dateFormatter,
  getInitials,
  newDateFormatter,
  fileTypeCheck,
  dateDiff,
  yearList,
} from "../../../../helpers";
import SuggestionSupport from "./SuggestionSupport.vue";
import ContinuityTracking from "../../../Admin/Modal/ContinuityTracking.vue";
export default {
  name: "CardDetail",
  data() {
    return {
      isComment: false,
      commentText: "",
      suggestionId: null,
      isSuggestionSupport: false,
      team: "",
      teamLead: "",
      valueCurrent: "",
      projectYear: "",
      projectYearList: [],
    };
  },
  components: {
    SuggestionSupport,
    ContinuityTracking,
  },
  filters: {
    suggestionStatusFilter(value) {
      return suggestionStatus(value);
    },
    dateFormatterFilter(value) {
      return dateFormatter(value);
    },
    newDateFormatterFilter(value) {
      return newDateFormatter(value);
    },
    getInitialsFilter(value) {
      return getInitials(value);
    },
    dateDiffFilter(value) {
      return dateDiff(value);
    },
  },
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
  },
  props: ["detailData", "isSuggestion"],
  methods: {
    close() {
      this.$emit("close", false);
      const $body = document.querySelector("body");
      $body.style.removeProperty("overflow");
    },
    async createComment() {
      const id =
        this.isSuggestion == "productidea-card"
          ? this.detailData.SuggestionId
          : this.detailData.Id;
      const body = {
        CommentText: this.commentText,
        SuggestionId: id,
        UserId: this.user.Data.UserId,
      };
      try {
        const res = await suggestionService.fetchCreateComment(body);
        if (res.Data) {
          this.commentText = null;
          this.$toast.success("Yorumunuz başarıyla yapılmıştır.", {
            position: "top",
          });
          if (this.isSuggestion == "productidea-card") {
            this.$store.dispatch("suggestionRD/deletePagedData");
            this.$store.dispatch("suggestionRD/setData");
          } else if (this.isSuggestion == "idea") {
            this.$store.dispatch("ideas/deleteData");
            this.$store.dispatch("ideas/setData", {
              pageSize: 15,
              pageIndex: 0,
              suggestionTypes: 1,
              companyId: 1,
            });
          } else if (this.isSuggestion == "my-idea-product") {
            this.$store.dispatch("ideas/deleteData");
            this.$store.dispatch("ideas/setData", {
              pageSize: 15,
              pageIndex: 0,
              suggestionTypes: 3,
              companyId: 1,
            });
          } else {
            this.$store.dispatch("suggestionNewests/deleteNewestsData");
            this.$store.dispatch("suggestionNewests/setData");
          }
          this.close();
        }
      } catch (error) {
        this.$toast.error("Yorumunuz gönderilirken bir hata oluştu.", {
          position: "top",
        });
      }
    },
    typeCheck() {
      this.detailData.DownloadFile.fileType = fileTypeCheck(
        this.detailData.DownloadFile.Extension
      );
    },
    supportShowModal(item) {
      this.suggestionId = item;
      this.isSuggestionSupport = true;
    },
    async sendContinuityTrackingUpdate(event) {
      let tmpData = {};

      for (let key in this.detailData) {
        tmpData[key] = this.detailData[key];
      }
      tmpData.ContinuityTrackingEvaluatorNote =
        event.continuityTrackingEvaluatorNote;
      tmpData.ContinuityTrackingEvaluatorReason =
        event.continuityTrackingEvaluatorReason;
      await this.updateModalAPI(tmpData);
    },
    async updateModalAPI(tmpData) {
      try {
        await suggestionRdService.fetchUpdateSuggestionRD(tmpData);
        this.$toast.success("Başarılı bir şekilde güncellendi.", {
          position: "top",
        });
        this.$store.dispatch("suggestion/deleteProductizationData");
        let tmpFilterData = {
          pageSize: 15,
          page: 0,
          loginUserId: this.user.Data.UserId,
          isAssignment: true,
        };
        this.$store.dispatch("ideas/deleteMyAssignmentData");
        this.$store.dispatch("ideas/setMyAssignmentsData", tmpFilterData);
        this.close();
      } catch (error) {
        this.$toast.error("Güncelleştirme başarısız.", {
          position: "top",
        });
      }
    },
  },
  async created() {
    this.projectYearList = yearList();
    const $body = document.querySelector("body");
    $body.style.overflow = "hidden";
    if (this.detailData.DownloadFile) this.typeCheck();

    if (this.detailData) {
      let valueCurrentList = [];
      let teamList = [];
      let teamLeaderList = [];
      this.detailData.SuggestionRDUserModels.forEach((element) => {
        if (element && element.UserStatus == "4") {
          valueCurrentList.push(element.UserName);
        }
        if (element && element.UserStatus == "2") {
          teamList.push(element.UserName);
        }
        if (element && element.UserStatus == "3") {
          teamLeaderList.push(element.UserName);
        }
      });
      this.valueCurrent = valueCurrentList.join();
      this.team = teamList.join();
      this.teamLead = teamLeaderList.join();
      this.projectYear = this.detailData.ProjectYear
        ? this.detailData.ProjectYear
        : "";
    }
  },
};
</script>